import React, { useRef, useState } from 'react';
import { Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import * as Yup from "yup";
import Switch from "react-bootstrap-switch";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";


// components
import ContactLangs from './_langs.js'
import SelectGeneric from '../../../components/select/selectGeneric'
import {
    ButtonCancel,
    ButtonSubmit,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import {getCurrentDateForCodeField} from "../../../util/DateTools";

// labels
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import { PH_CODE, PH_ICON, PH_VALUE } from "../../../components/i18n/placeHolders";
import { FL_CATEGORY, FL_CODE, FL_ICON, FL_VALUE } from "../../../components/i18n/formLabels";
import { FORM, INTERNATIONAL, LB_ACTIVE, LB_CONTACT_TYPE, LB_ORDER, REQUIRED } from "../../../components/i18n/i18n";

// providers
import { typeContactProvider } from "../../../providers/typeContactProvider";
import { hotelCategoryProvider } from "../../../providers/hotelCategoryProvider";

// actions
import { save, update } from "../../../redux/actions/contactActions";
import {setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {genericActions} from "../../../redux/actions/generics/GenericActions";
import {contactService} from "../../../jwt/_services/hotel/contactService";

const ContactForm = props => {
    const { udn, app } = props.mainProps;
    const { editMode, domainObject } = props.formProps;
    const translatableLangs = domainObject?.translatedLangs || []

    const [category, setCategory] = useState(domainObject?.category?.id || null)
    const [contactType, setContactType] = useState(domainObject?.typeContact?.id || null)
    const [status, setStatus] = useState(domainObject?.status != null ? domainObject?.status : null);
    const [langs, setLangs] = useState(domainObject?.langs || []);
    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required( REQUIRED )
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id        : domainObject?.id,
            uid       : domainObject?.uid,
            code      : (domainObject?.code || `${udn?.code}_contact_` + getCurrentDateForCodeField()).toLowerCase(), // AUTOCODE
            value     : domainObject?.value,
            icon      : domainObject?.icon,
            showOrder : domainObject?.showOrder,
            status    : domainObject?.status,
        }
    });

    const onSubmit = (data, _) => {

        const dataRequest = {
            fbDataBase:  { id : app?.fbDataBase?.id },
            item: {
               ...data,
                status: status,
                category: category && { id: category},
                typeContact: contactType && { id: contactType },
                udn: { id: udn?.id },
                langs: langs
            }
        }

        if (editMode) {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericActions.update(contactService, id, dataRequest)
        } else {
            genericActions.save(contactService, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.setItem(null);
        props.setForm();
        props.onClose()
    }

    return (<Card className={'card-modal'}>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-edit mr-2"/>{FORM}
            {
                editMode && <div className="float-right">
                    <GenericTableButton
                        toolTip={TT_HISTORY}
                        icon={'fa-clock'}
                        permission={'search'}
                        onClick={showHistory}
                    />
                </div>
            }
        </CardTitle>
        <CardBody>
            <Form onSubmit={ handleSubmit(onSubmit) }>
                <Row>
                    <Col  md="8">
                        <FormGroup>
                            <Label>{FL_CODE}</Label>
                            <Input
                                type="text"
                                name="code"
                                placeholder={PH_CODE}
                                innerRef={register}

                                className={(errors.code ? ' is-invalid' : '')}
                            />
                            { errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                        </FormGroup>
                    </Col>
                    <Col  md="4">
                        <FormGroup>
                            <Label>{FL_ICON}</Label>
                            <Input
                                type="text"
                                name="icon"
                                placeholder={PH_ICON}
                                innerRef={register}

                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col  md="12">
                        <FormGroup>
                            <Label>{FL_VALUE}</Label>
                            <Input
                                type="text"
                                name="value"
                                placeholder={PH_VALUE}
                                innerRef={register}

                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col  md="6">
                        <FormGroup>
                            <Label>{LB_CONTACT_TYPE}</Label>
                            <br/>
                            <SelectGeneric
                                initialValue={ contactType }
                                setExternalValue={ setContactType }
                                provider={ typeContactProvider }
                            />
                        </FormGroup>
                    </Col>
                    <Col  md="6">
                        <FormGroup>
                            <Label>{FL_CATEGORY}</Label>
                            <br/>
                            <SelectGeneric
                                initialValue={ category }
                                setExternalValue={ setCategory }
                                provider={ hotelCategoryProvider }
                            />
                        </FormGroup>
                    </Col>
                </Row>


                <Row>
                    <Col md="3">
                        <FormGroup>
                            <Label>{LB_ORDER}</Label>
                            <Input
                                type="number"
                                name="showOrder"
                                placeholder="Orden"
                                min='0'
                                innerRef={register}
                                
                                />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>{LB_ACTIVE}</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={ status }
                                onChange={ _ => setStatus(!status) }
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="fas fa-language mr-2"/>
                    {INTERNATIONAL}
                </CardTitle>

                <CardBody>
                    <ContactLangs
                        langs={langs}
                        setLangs={setLangs}
                        translatableLangs={translatableLangs}
                    />
                </CardBody>

                <CardBody className="border-top">
                    <div className="float-right">
                        <ButtonSubmit/>
                        <ButtonCancel onClick={ closeForm }/>
                    </div>
                </CardBody>
            </Form>
        </CardBody>
        {
            showModal && <LogHistoryModal
                ref={ modalRef }
                item={ domainObject }
            />
        }
    </Card>)
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setItem,
    setForm,
    save,
    update,
})

export default connect(mapStateToProps, mapActionsToProps)(ContactForm)
